import { onMounted, ref, reactive, computed } from 'vue';
import { API, graphqlOperation } from 'aws-amplify';
import { Autoplay } from 'swiper';

import { logintest, awsNow } from '@/lib/common';
import { config } from '@/config';

import { listNews } from '@/graphql/queries';
import { News, User } from '@/@types/d';

export const TopNewsSwiperComponentSetup = () => {
  const swiperModules = [Autoplay];
  const currentUser = ref({} as User);

  const loggedIn = ref(false);
  const news = ref<News[]>([{id: 'a', displayFrom: 1, title: 'a'}]);
  // 値を入れて初期化しないとswiper autoplayが動作しない

  onMounted(async () => {
    logintest(initView, clearView, {user:currentUser, state:loggedIn});
  });

  const initView = () => {
    queryNews();
  };
  const clearView = () => {
    news.value = [];
  };

  // ニュース取得 query
  const queryNews = async () => {
    const n = awsNow();
    const params = {
      filter: {and: {displayFrom: {le: n}, displayTo: {ge: n}}},
      limit: 50,
    };
    const res: any = await API.graphql(graphqlOperation(listNews, params));
    if(res) {
      news.value = res.data.listNews.items;
    }
  };

  const listNewsContents = computed((): News[] => {
    return news.value
      .sort((a: News, b: News) => (b.displayFrom||0) - (a.displayFrom||0))
      .slice(0, config.NEWS_TOP_ARTICLES_LEN);
  });

  return {
    swiperModules,
    listNewsContents
  };
};
